import { Col, Row, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";

import { Button, Modal } from "antd";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { LinkOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import HeadingBack from "../../../component/HeadingBack";
import AbhaLinkedFilter from "../AbhaFilter";
import moment from "moment";
import { usePermission } from "../../../hooks/usePermission";
import { DashboardServices } from "../../../redux/Services";
import { Outlet, Link } from "react-router-dom";
import { fetchconsentLogs } from "../../../redux/Services/DashboardServices";

const ConsentGrant = () => {
  const permission = usePermission("HIU Dashboard", "List");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [isColored, setIsColored] = useState(false);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({});
  const CconsentGrantLogs = useSelector(
    (state) => state.dashboard.CconsentGrantLogs || []
  );
  const totalCconsentGrantLogs = useSelector(
    (state) => state.dashboard.totalCconsentGrantLogs || []
  );
  // const { mutate: fetchconsentLogs, isLoading } = useMutation((data) =>
  //   dispatch(DashboardServices.fetchconsentLogs({ page: 1, limit: 50 }))
  // );
  const { mutate: fetchconsentLogs, isLoading } = useMutation((data) =>
    dispatch(DashboardServices.fetchconsentLogs(data))
  );

  const { mutate: constentArtifactDetailsFetch } = useMutation((data) =>
    dispatch(DashboardServices.constentArtifactDetailsFetch(data, navigate))
  );
  const [modal1Open, setModal1Open] = useState(false);
  const [raw, setRaw] = useState({});
  const [ModalNotify, setModalNotify] = useState(false);
  const handleFetchArtifactDetail = (consentRequestId) => {
    // constentArtifactDetailsFetch({ consentRequestId }, { onSuccess: () => {navigate("/hiu-consent-artifact-details")}});
    constentArtifactDetailsFetch({ consentRequestId });
  };

  //   useEffect(() => {
  //     console.log("filter", filter);

  //     fetchconsentLogs({ ...filter, page, limit: 10 });
  //   }, []);

  useEffect(() => {
    fetchconsentLogs({ ...filter, page, limit });
    return () => {};
  }, [filter,page,limit]);

  useEffect(() => {
    setTotal(totalCconsentGrantLogs);
  }, [totalCconsentGrantLogs]);

  // console.log(abhaCreatedList?.setRaw);
  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * limit + index + 1,
    },
    {
      title: "Action (Fetch HIP)",
      dataIndex: "action",
      key: "actiion",
      className: "abha-link-action",
      render: (value, item, index) => {
        let id = JSON.parse(item?.response_raw_data || "{}")?.notification
          ?.consentRequestId;
        var status =
          JSON.parse(item?.response_raw_data || "{}")?.notification?.status ||
          null;
        return status === "DENIED" ? (
          ""
        ) : (
          <Tooltip placement="top" title={"Fetch HIP"}>
            <Button
              className="view-btn"
              type="primary"
              onClick={() => handleFetchArtifactDetail(id)}
            >
              <LinkOutlined />
            </Button>
          </Tooltip>
        );
      },
    },
    {
      title: "Log Id",
      dataIndex: "id",
      key: "id",
      className: "table_status_col",
    },
    {
      title: "Log Type",
      dataIndex: "log_type",
      key: "log_type",
      className: "table_status_col",
      name: "type",
      // render: (value, item, index) => {
      //     return (
      //         <span>{"Callback"}</span>
      //     )
      // }
    },
    {
      title: "Request Id",
      dataIndex: "request_id",
      key: "id",
      className: "text-capitalize",
    },
    {
      title: "Consent Request Id",
      dataIndex: "consentRequestId",
      key: "consentRequestId",
      className: "abha-link-date",
      render: (value, item, index) => {
        return (
          <>
            {
              JSON.parse(item?.response_raw_data || "{}")?.notification
                ?.consentRequestId
            }
          </>
        );
      },
    },
    {
      title: "Requester (HIU/HIP)",
      dataIndex: "requestor",
      key: "requestor",
      className: "text-capitalize",
    },

    {
      title: "Date Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "abha-link-date",
      render: (value, item, index) => {
        return (
          <span>
            <> {moment.utc(item.createdAt).format("DD-MM-YYYY H:mm:ss")} </>
          </span>
        );
      },
    },

    {
      title: "Status",
      dataIndex: "consent_status",
      key: "consent_status",
      className: "text-capitalize",
      render: (value, record, index) => {
        return record?.consent_status == "DENIED" ||
          record?.consent_status == "REVOKED" ? (
          <span style={{ color: "red" }}>{record?.consent_status}</span>
        ) : record?.consent_status == "GRANTED" ? (
          <span style={{ color: "green" }}>{record?.consent_status}</span>
        ) : record?.consent_status == "REQUEST PENDING" ? (
          <span style={{ color: "orange" }}>{record?.consent_status}</span>
        ) : (
          <span>{record?.consent_status}</span>
        );
      },
    },

    {
      title: "Response Data",
      dataIndex: "Status",
      key: "Status",
      className: "table_status_col",
      render: (value, item, index) => {
        return (
          <>
            <Button
              className="view-btn"
              type="primary"
              onClick={() => {
                setRaw(JSON.parse(item?.response_raw_data || "{}"));
                setModal1Open(true);
              }}
            >
              {" "}
              View
            </Button>
          </>
        );
      },
    },
  ];
  return (
    <div>
      <Row gutter={[10, 10]} align={"middle"}>
        <Col lg={3} md={24} sm={24} xs={24}>
          <HeadingBack
            title={"Consent Grant"}
            subHeading={`Records ${totalCconsentGrantLogs || 0}`}
          />
        </Col>
        <Col lg={19} md={12} sm={24} xs={24}>
          <AbhaLinkedFilter
            filter={filter}
            setFilter={setFilter}
            setPage={setPage}
            searchHide={true}
          />
        </Col>
        {/* <Col lg={2} md={24} sm={24} xs={24}>
                    <div className='flex justify-content-end align-items-center'>
                        <Tooltip title="Add"><span className='jop_btn' onClick={() => navigate("/faq/add")}>Add<SvgIcon.Add width={40} height={40} className="cursor-pointer" /></span></Tooltip>
                    </div>
                </Col> */}
      </Row>
      <div className="tableResponsive mt-10">
        <Table
          rowKey="Id"
          bordered
          columns={columns}
          dataSource={Array.isArray(CconsentGrantLogs) ? CconsentGrantLogs : []}
          pagination={{
            current: page,
            pageSize: limit,
            total: totalCconsentGrantLogs,
            onChange(current, pageSize) {
              setPage(current);
              setLimit(pageSize);
            },
            hideOnSinglePage: false,
            showSizeChanger: true,
          }}
        />
      </div>

      <Modal
        style={{
          top: 20,
        }}
        open={modal1Open}
        onOk={() => setModal1Open(false)}
        onCancel={() => {
          setRaw({});
          setModal1Open(false);
        }}
        footer={null}
      >
        <pre>{JSON.stringify(raw, null, 2)}</pre>
      </Modal>
    </div>
  );
};

export default ConsentGrant;
